import { createAction } from '@reduxjs/toolkit';
import { ActionNames, Errors } from '_constants'
import { patientService } from '_services';
import { alertActions } from './alert.actions';


export const cdvActions = {
    toggleClinicalDocsVisibility: createAction(ActionNames.CDV_TOGGLE_CLINICAL),
    toggleFotoDocsVisibility: createAction(ActionNames.CDV_TOGGLE_FOTO),
    refreshCdv: (ptno) => (dispatch) => {
        dispatch(cdvActions.refreshCdvRequest({ ptno }));

        patientService.loadCdv(ptno)
            .then(
                response => {
                    dispatch(cdvActions.refreshCdvSuccess({ ptno, response }));
                }
                ,
                error => {
                    dispatch(cdvActions.refreshCdvFailure({ ptno, error }));
                    dispatch(alertActions.error(Errors.CDV_REFRESH_FAILURE));
                }
            );
    },
    refreshCdvRequest: createAction(ActionNames.CDV_REFRESH_REQUEST),
    refreshCdvSuccess: createAction(ActionNames.CDV_REFRESH_SUCCESS),
    refreshCdvFailure: createAction(ActionNames.CDV_REFRESH_FAILURE),

}
